<template lang="pug">
  div.e-breadcrumbs.breadcrumps
    a(
    href="#"
    v-if="firstLinkIsMenu"
    @click.stop.prevent="$store.commit('toggleMenu')"
    ).breadcrumps__level
      b {{$translate('Меню')}}
    router-link(
      v-for="link,i in breadcrumbsLinks"
      :key="i"
      :to="link"
    ).breadcrumps__level {{$translate(link.meta.title)}}
</template>

<script>
  import url from '../../utils/url.js'

  export default {
    name: 'e-breadcrumbs',
    props: {
      firstLinkIsMenu: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      breadcrumbsLinks () {
        if (this.$store.getters.breadcrumbs(this.$route.name)) {
          return this.$store.getters.breadcrumbs(this.$route.name)
        }
        let prev = url.encode(url.getPrevRoute(this.$route))
        let tmp = []
        let prevMatchedRouteTitle = null
        if (this.$route.matched) {
          this.$route.matched.forEach(v => {
            let link = v
            if (prev && link.name === prev.name) {
              link = Object.assign(link, prev)
            }
            if (link.meta && link.meta.title) {
              if (link.meta.showInBreadcrumb) {
                if (link.meta.showInBreadcrumb(this.$route.matched, v) === true) {
                  tmp.push(link)
                }
              } else {
                if (prevMatchedRouteTitle !== link.meta.title) {
                  tmp.push(link)
                }
              }
              prevMatchedRouteTitle = link.meta.title
            }
          })
        }
        if (tmp.length === 0) {
          tmp.push({path: '/', meta: {title: this.$translate('Главная')}})
        }

        // debugger
        return tmp
      }
    }
  }
</script>
